import TeacherExperience from './src/main';

/* istanbul ignore next */
TeacherExperience.install = function(Vue) {
  Vue.component(TeacherExperience.name, TeacherExperience);
};

export default TeacherExperience;
